import { Navigate, Outlet } from "react-router-dom";
import { useCookies } from "react-cookie";
import React, { FC } from "react";
import { CiidAccessTokenPayload } from "../types";
import { Error404 } from "../pages/Error404";
import { ROUTE_PERMISSIONS, RoutePath } from "../constants/routes.const";
import { dispatch } from "../store";
import { changeUserRoleAction } from "../store/users/actions";

interface IPrivateProps {
  redirectTo?: string;
}

const PrivateRoute: FC<IPrivateProps> = ({ redirectTo = "/" }) => {
  const [cookies] = useCookies(["ciid_access_token"]);
  let isLogged = false;
  let havePermission = false;

  if (cookies.ciid_access_token) {
    const payload: CiidAccessTokenPayload = JSON.parse(
      atob(cookies.ciid_access_token.split(".")[1]),
    );

    dispatch(changeUserRoleAction(payload.role));
    const path = location.pathname.split("/")[1] as RoutePath;
    const userPermissions = ROUTE_PERMISSIONS[payload.role] || [];
    havePermission = userPermissions.includes(path);
    isLogged = cookies.ciid_access_token.length !== 0;
  }

  return (
    <>
      {isLogged ? havePermission ? <Outlet /> : <Error404 /> : <Navigate replace to={redirectTo} />}
    </>
  );
};
export default PrivateRoute;
